// extracted by mini-css-extract-plugin
module.exports = {"FranchizePage":"FranchizePage_FranchizePage__U13Nc"};